/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCallAnswererFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type CallAnswerer, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /calls/answerers
 */
export interface AnswerersRequestBuilder extends BaseRequestBuilder<AnswerersRequestBuilder> {
    /**
     * GetCallAnswerers
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CallAnswerer[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CallAnswerer[] | undefined>;
    /**
     * GetCallAnswerers
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const AnswerersRequestBuilderUriTemplate = "{+baseurl}/calls/answerers";
/**
 * Metadata for all the requests in the request builder.
 */
export const AnswerersRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: AnswerersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCallAnswererFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
